import { Component, OnInit, ViewChild, TemplateRef, inject } from "@angular/core";
import { FormsModule, ReactiveFormsModule, FormGroup, FormBuilder } from "@angular/forms";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzSelectModule } from "ng-zorro-antd/select";
import { LookupService } from "../../../../../services/lookup.service";
import { ProviderService } from "../../../../../services/provider.service";
import { TimesheetService } from "../../../../../services/timesheet.service";
import { UserService } from "../../../../../services/user.service";
import { AllowListAuthStore } from "../../../../../shared/authorization/allow-list-auth.store";
import { AuthorizationUtility } from "../../../../../shared/authorization/auth.utility";
import { AuthorizeDirective } from "../../../../../shared/authorization/authorize.directive.";
import { AccordionComponent, ButtonComponent, DatepickerComponent, ListTableComponent } from "@ppl/ui";
import { MEMBER_VIEW_PAGE_IDS, TABS } from "../../../../../shared/constants/page.constants";
import { STATIC_DATA } from "../../../../../shared/constants/static-data.constants";
import { TableRowActions } from "../../../../../shared/interfaces/actions";
import { TableRowActionsModel } from "../../../../../shared/interfaces/list.interface";
import { NgZorroModule } from "../../../../../shared/modules/ng-zorro/ng-zorro.module";
import { DialogService, DialogConfig } from "../../../../../shared/services/dialog.service";
import { ListService } from "../../../../../shared/services/list.service";
import { DateTimeFormatterService } from "../../../../../shared/utils/date-time-formatter.service";
import { AddInvoiceComponent } from "../../provider/provider-invoice/add-invoice/add-invoice.component";

@Component({
  selector: 'ppl-invoice-consumer-list',
  standalone: true,
  imports: [
    AccordionComponent,
    ListTableComponent,
    NgZorroModule,
    ButtonComponent,
    AuthorizeDirective,
    NzSelectModule,
    FormsModule,
    NzFormModule,
    ReactiveFormsModule,
    AddInvoiceComponent,
    DatepickerComponent
  ],
  templateUrl: './invoice-consumer-list.component.html',
  styleUrls: ['./invoice-consumer-list.component.css'],
})
export class InvoiceConsumerListComponent implements OnInit {
  @ViewChild('inProcessInvoiceChildComponent') inProcessInvoiceChildComponent?: ListTableComponent;
  @ViewChild('completedInvoiceChildComponent') completedInvoiceChildComponent?: ListTableComponent;
  entry!: string;
  sharedDataKey: string = STATIC_DATA.SHARED_REFERRAL_DATA;
  pageId = '';
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  actionButtonsProcessed: TableRowActionsModel = new TableRowActions({
    view: true,
  });
  actionButtonsInProcess: TableRowActionsModel = new TableRowActions({
    view: true,
  });
  @ViewChild('addInvoiceDialog') addInvoiceDialog!: TemplateRef<any>;
  @ViewChild('denyDialog') denyDialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  tabId: string = TABS.TIMESHEET;
  inProcessInvoiceSearchForm!: FormGroup;
  invoiceSearchForm!: FormGroup;
  programName!: string;
  timeEntry = '';
  listOfOption: any;
  consumerId: any;
  consumerLineData: any;
  rowData: any;
  providers: any[] = [];
  payPeriod: any[] = [];
  inprocessInvoices: any[] = [];
  processedInvoices: any[] = [];
  private inProcessSearchParams: any[] = [];
  private processedSearchParams: any[] = [];
  viewDialogId: any;
  businessStatusList: any;
  processingStatusList: any;
  reasonList: any;
  providerData: any;
  selectedReason: any;
  inProcessFilterStatus = [
    {
      lkpValueCode: 'AC',
      lkpValueName: 'Awaiting approval',
    },
    {
      lkpValueCode: 'GP',
      lkpValueName: 'Good to pay',
    },
    {
      lkpValueCode: 'I',
      lkpValueName: 'In review',
    },
  ];

  status = [
    {
      lkpValueCode: 'D',
      lkpValueName: 'Denied',
    },
    {
      lkpValueCode: 'CD',
      lkpValueName: 'Participant rejected',
    },
    {
      lkpValueCode: 'P',
      lkpValueName: 'Paid',
    },
  ];

  cols = [
    {
      field: 'invoiceDate',
      header: 'Invoice Date',
      jsonpath: 'invoiceDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: "invoiceNumber",
      header: "Invoice Number",
      jsonpath: "invoiceNumber",
      isDisplayedAtHeader: "y",
      isSearchable: "y"
    },
    {
      field: 'serviceDates',
      header: 'Service Dates',
      jsonpath: 'serviceDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'providerName',
      header: 'Provider Name',
      jsonpath: 'providerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'providerPplId',
      header: 'Provider PPL ID',
      jsonpath: 'providerPplId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: "totalCost",
      header: "Invoice Total Amount",
      jsonpath: "totalCost",
      isDisplayedAtHeader: "y",
      isSearchable: "y"
    },
    {
      field: "inProcessCount",
      header: "In Process Service Lines",
      jsonpath: "inProcessCount",
      isDisplayedAtHeader: "y",
      isSearchable: "y"
    },
    {
      field: "processedCount",
      header: "Processed Service Lines",
      jsonpath: "processedCount",
      isDisplayedAtHeader: "y",
      isSearchable: "y"
    }
  ];

  processedInvoiceColumns = [
    {
      field: 'invoiceDate',
      header: 'Invoice Date',
      jsonpath: 'invoiceDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'invoiceNumber',
      header: 'Invoice Number',
      jsonpath: 'invoiceNumber',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceDates',
      header: 'Service Dates',
      jsonpath: 'serviceDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'providerName',
      header: 'Provider Name',
      jsonpath: 'providerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'providerPplId',
      header: 'Provider PPL ID',
      jsonpath: 'providerPplId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'totalCost',
      header: 'Total Cost',
      jsonpath: 'totalCost',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paidLines',
      header: 'Paid Lines',
      jsonpath: 'paidLines',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'deniedLines',
      header: 'Denied Lines',
      jsonpath: 'deniedLines',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    }
  ]

  // Tags the Service Dates cell so its comma separated value can render one date per line.
  serviceDatesCellClassResolver = (_rowData: any, col: any): string =>
    col?.field === 'serviceDates' ? 'service-dates-cell' : '';

  isReadOnly = false;
  isSectionVisible = true;
  isSectionEditable = false;
  isSectionDeletable = false;
  canApproveReject = true;

  constructor(
    private fb: FormBuilder,
    private lookupService: LookupService,
    private listService: ListService,
    private userService: UserService,
    private providerService: ProviderService,
    private timesheetService: TimesheetService,
    private allowListStore: AllowListAuthStore,
    private authUtility: AuthorizationUtility,
    private dateTimeFormatter: DateTimeFormatterService
  ) { }

  ngOnInit(): void {
    this.entry = this.userService.getLeadEntry() ?? '';
    this.pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.consumerId = this.userService.getSelectedLead()!;

    this.businessStatusList = this.lookupService.getLookupValue('Invoice_Business_Status');
    this.processingStatusList = this.lookupService.getLookupValue('Invoice_Processing_Status');
    this.reasonList = this.lookupService.getLookupValue('Manual Entry reason');

    const denyReasons = this.lookupService.getLookupValue(
      'consumer_ts_denial'
    );
    this.listOfOption = denyReasons.map((item: any) => item.lkpValueName);
    const userDetails = this.userService.getUserDetails();
    const isInRole = selectedProgram?.roles.some((role: any) => role.role_name === 'PPL Staff Tier 1') && userDetails?.usertype_lkp === 'FMS';
    if (isInRole) {
      this.isReadOnly = true;
    }
    this.inProcessInvoiceSearchForm = this.fb.group({
      paPplId: [null],
      paName: [null],
      status: [null],
      serviceDate: [null],
    });
    this.invoiceSearchForm = this.fb.group({
      payPeriod: [null],
      provider: [null],
      status: [null],
      serviceDate: [null],
    });
    this.setPageAccess();
    this.getProviders();
    this.getPayPeriod();
    this.loadInitData();
  }

  loadInitData() {
    this.loadInProgressData();
    this.loadProcessedData();
  }

  onInProcessInvoicePageLoad(event: any) {
    this.loadInProgressData(event.startingPageNumber ?? 1, event.first ?? 0, event.rows ?? 10);
  }

  onCompletedInvoicePageLoad(event: any) {
    this.loadProcessedData(event.startingPageNumber ?? 1, event.first ?? 0, event.rows ?? 10);
  }

  loadProcessedData(startingPageNumber = 1, currentPage = 0, recordsPerPage = 10) {
    const processedPayload = this.buildRequestPayload(
      'invoice-consumer-completed',
      startingPageNumber,
      this.processedSearchParams,
      recordsPerPage,
    );
    this.listService
      .getListData(processedPayload, 'claims')
      .subscribe((data: any) => {
        const processedData = this.prepareInvoices(data.responsedata);

        if (startingPageNumber > 1) {
          this.processedInvoices = [...this.processedInvoices, ...processedData];
        } else {
          this.processedInvoices = processedData;
        }

        if (this.completedInvoiceChildComponent) {
          this.completedInvoiceChildComponent.recordsPerPage = recordsPerPage;
          this.completedInvoiceChildComponent.resetPagination(startingPageNumber, currentPage);
        }
        this.invoiceSearchForm.reset();
      });
  }

  /**
   * Refresh clears the filters as well as reloading. Both loaders reset their form once the
   * data arrives, so the applied search params outlive the values the user can still see —
   * without clearing them a refresh would silently re-apply the last search against an
   * empty-looking filter bar.
   */
  refreshInProcessInvoices() {
    this.inProcessSearchParams = [];
    this.inProcessInvoiceSearchForm.reset();
    this.loadInProgressData(1, 0, this.inProcessInvoiceChildComponent?.recordsPerPage ?? 10);
  }

  refreshProcessedInvoices() {
    this.processedSearchParams = [];
    this.invoiceSearchForm.reset();
    this.loadProcessedData(1, 0, this.completedInvoiceChildComponent?.recordsPerPage ?? 10);
  }

  getPayPeriod() {
    this.timesheetService
      .getPayPeriod(this.programName)
      .subscribe((data: any) => {
        this.payPeriod = data.responsedata;
      });
  }

  loadInProgressData(startingPageNumber = 1, currentPage = 0, recordsPerPage = 10) {
    const inProcessPayload = this.buildRequestPayload(
      'invoice-consumer-inProcess',
      startingPageNumber,
      this.inProcessSearchParams,
      recordsPerPage,
    );
    this.listService
      .getListData(inProcessPayload, 'claims')
      .subscribe((data: any) => {
        const records = this.prepareInvoices(data.responsedata);
        this.inProcessInvoiceSearchForm.reset();

        if (startingPageNumber > 1) {
          this.inprocessInvoices = [...this.inprocessInvoices, ...records];
        } else {
          this.inprocessInvoices = records;
        }

        if (this.inProcessInvoiceChildComponent) {
          this.inProcessInvoiceChildComponent.recordsPerPage = recordsPerPage;
          this.inProcessInvoiceChildComponent.resetPagination(startingPageNumber, currentPage);
        }
      });
  }

  buildRequestPayload(pageName: string, startingPageNumber: number, searchParams: any = [], recordsPerPage = 10): any {
    const defaultSearchParams = {
      jsonPath: 'consumerId',
      value: this.consumerId,
      operator: 'Equal',
    };

    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams.length > 0 ? searchParams : [defaultSearchParams],
      orderByColumn: ['invoiceHeaderId'],
      orderBy: ['desc'],
    };

    return payload;
  }

  getProviders() {
    this.providerService
      .getProviderList(this.programName, this.consumerId)
      .subscribe((data: any) => {
        this.providers = data.responsedata;
      });
  }

  inProcessTimesheetSearch() {
    const formData = this.inProcessInvoiceSearchForm.value;
    const searchParam: { jsonPath: string; value: any; operator: string }[] = [
      {
        jsonPath: 'consumerId',
        value: this.consumerId,
        operator: 'Equal',
      },
    ];

    if (formData.paPplId && formData.paPplId.trim()) {
      searchParam.push({
        jsonPath: 'providerPplId',
        value: formData.paPplId.trim(),
        operator: 'Equal',
      });
    }

    if (formData.paName) {
      searchParam.push({
        jsonPath: 'providerId',
        value: formData.paName,
        operator: 'Equal',
      });
    }

    if (formData.status) {
      searchParam.push({
        jsonPath: 'businessStatus',
        value: formData.status,
        operator: 'Contains',
      });
    }

    // The picker hands back a Date; the list API expects serviceDate as MM/dd/yyyy.
    if (formData.serviceDate) {
      searchParam.push({
        jsonPath: 'serviceDate',
        value: this.dateTimeFormatter.formatDateToString(formData.serviceDate as Date),
        operator: 'Equal',
      });
    }

    this.inProcessSearchParams = searchParam;
    this.loadInProgressData(1, 0, this.inProcessInvoiceChildComponent?.recordsPerPage ?? 10);
  }

  search() {
    const formData = this.invoiceSearchForm.value;
    const searchParam: { jsonPath: string; value: any; operator: string }[] = [
      {
        jsonPath: 'consumerId',
        value: this.consumerId,
        operator: 'Equal',
      },
    ];

    if (formData.provider) {
      searchParam.push({
        jsonPath: 'providerId',
        value: formData.provider,
        operator: 'Equal',
      });
    }

    if (formData.status) {
      searchParam.push({
        jsonPath: 'businessStatus',
        value: formData.status,
        operator: 'Contains',
      });
    }

    if (formData.payPeriod) {
      searchParam.push({
        jsonPath: "paidPayrollScheduleId",
        value: formData.payPeriod,
        operator: "Equal"
      });
    }

    // The picker hands back a Date; the list API expects serviceDate as MM/dd/yyyy.
    if (formData.serviceDate) {
      searchParam.push({
        jsonPath: 'serviceDate',
        value: this.dateTimeFormatter.formatDateToString(formData.serviceDate as Date),
        operator: 'Equal',
      });
    }

    this.processedSearchParams = searchParam;
    this.loadProcessedData(1, 0, this.completedInvoiceChildComponent?.recordsPerPage ?? 10);
  }

  onAction(event: any) {
    this.rowData = event.data;
    const provider = this.providers.find(p => p.providerId === this.rowData?.providerId);
    this.providerData = {
      id: provider?.providerId,
      name: provider?.providerFullName,
      providerPplId: provider?.providerPplId
    }
    if (event.action === 'view') {
      this.openViewPopup();
    }
  }

  openViewPopup() {
    const dialogConfig: DialogConfig = {
      title: 'View Invoice',
      okText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.viewDialogId = this.dialogSvc.openDialog(
      this.addInvoiceDialog,
      dialogConfig,
      () => this.handleCancel({ isCloseTriggeredByDialog: true }),
      () => this.handleCancel({ isCloseTriggeredByDialog: true })
    );
  }

  handleCancel(event: any) {
    if (((Array.isArray(event) && event[0]?.invoiceHeaderId) || event?.isCloseTriggeredByDialog) && this.viewDialogId) {
      this.dialogSvc.closeDialog(this.viewDialogId);
      this.viewDialogId = '';
    }
  }

  handleInvoiceUpdated(event: any) {
    if (event) {
      this.loadInProgressData();
    }
  }

  private setPageAccess() {
    const pageConfig = this.allowListStore.getConfig()?.pages[this.pageId];
    if (pageConfig) {
      const allowedActions = this.allowListStore.getAllowedActions(this.pageId);
      const allowedButtons = this.allowListStore.getAllowedButtons(this.pageId);
      // Combine role-based check with page-level access
      this.isReadOnly = this.isReadOnly || (allowedActions.length === 0 && allowedButtons.length === 0);
      this.isSectionVisible = this.authUtility.isSectionVisible(this.pageId, 'invoice', 'Invoice');
      this.isSectionEditable = this.authUtility.isSectionEditable(this.pageId, 'invoice', 'Invoice');
      this.isSectionDeletable = this.authUtility.isSectionDeletable(this.pageId, 'invoice', 'Invoice');
    } else {
      this.isReadOnly = true;
      this.isSectionVisible = false;
      this.isSectionEditable = false;
      this.isSectionDeletable = false;
    }
    this.canApproveReject = this.allowListStore.isButtonAllowed(this.pageId, 'approveReject');
    this.isPageRestrictionLoaded = true;
  }

  /**
   * Normalises a page of invoices for display: totals rounded to cents, and the API's
   * yyyy-MM-dd serviceDate turned into MM/dd/yyyy values rendered one per line.
   */
  private prepareInvoices(data: any[]): any[] {
    return (data || []).map((i: any) => ({
      ...i,
      totalCost: i.totalCost != null ? +Number(i.totalCost).toFixed(2) : i.totalCost,
      serviceDates: this.dateTimeFormatter.formatServiceDateList(i.serviceDate)
    }));
  }
}
